module.exports = __webpack_public_path__ + "fonts/Merriweather-300-vietnamese9.11350f7.woff2";